// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file dymensionxyz/dymension/common/rollapp_packet.proto (package dymensionxyz.dymension.common, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Packet } from "../../../ibc/core/channel/v1/channel_pb.js";
import { Status } from "./status_pb.js";

/**
 * @generated from message dymensionxyz.dymension.common.RollappPacket
 */
export class RollappPacket extends Message<RollappPacket> {
  /**
   * @generated from field: string rollapp_id = 1;
   */
  rollappId = "";

  /**
   * @generated from field: ibc.core.channel.v1.Packet packet = 2;
   */
  packet?: Packet;

  /**
   * @generated from field: bytes acknowledgement = 3;
   */
  acknowledgement = new Uint8Array(0);

  /**
   * @generated from field: dymensionxyz.dymension.common.Status status = 4;
   */
  status = Status.PENDING;

  /**
   * @generated from field: uint64 ProofHeight = 5;
   */
  ProofHeight = protoInt64.zero;

  /**
   * @generated from field: bytes relayer = 6;
   */
  relayer = new Uint8Array(0);

  /**
   * @generated from field: dymensionxyz.dymension.common.RollappPacket.Type type = 7;
   */
  type = RollappPacket_Type.ON_RECV;

  /**
   * stores the result of onAck, onTimeout or onRecv/writeAck
   *
   * @generated from field: string error = 8;
   */
  error = "";

  /**
   * who was the original person who gets the money (recipient of ics20 transfer) of the packet?
   *
   * @generated from field: string original_transfer_target = 9;
   */
  originalTransferTarget = "";

  constructor(data?: PartialMessage<RollappPacket>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dymensionxyz.dymension.common.RollappPacket";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "rollapp_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "packet", kind: "message", T: Packet },
    { no: 3, name: "acknowledgement", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(Status) },
    { no: 5, name: "ProofHeight", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "relayer", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 7, name: "type", kind: "enum", T: proto3.getEnumType(RollappPacket_Type) },
    { no: 8, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "original_transfer_target", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RollappPacket {
    return new RollappPacket().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RollappPacket {
    return new RollappPacket().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RollappPacket {
    return new RollappPacket().fromJsonString(jsonString, options);
  }

  static equals(a: RollappPacket | PlainMessage<RollappPacket> | undefined, b: RollappPacket | PlainMessage<RollappPacket> | undefined): boolean {
    return proto3.util.equals(RollappPacket, a, b);
  }
}

/**
 * @generated from enum dymensionxyz.dymension.common.RollappPacket.Type
 */
export enum RollappPacket_Type {
  /**
   * @generated from enum value: ON_RECV = 0;
   */
  ON_RECV = 0,

  /**
   * @generated from enum value: ON_ACK = 1;
   */
  ON_ACK = 1,

  /**
   * @generated from enum value: ON_TIMEOUT = 2;
   */
  ON_TIMEOUT = 2,

  /**
   * @generated from enum value: UNDEFINED = -1;
   */
  UNDEFINED = -1,
}
// Retrieve enum metadata with: proto3.getEnumType(RollappPacket_Type)
proto3.util.setEnumType(RollappPacket_Type, "dymensionxyz.dymension.common.RollappPacket.Type", [
  { no: 0, name: "ON_RECV" },
  { no: 1, name: "ON_ACK" },
  { no: 2, name: "ON_TIMEOUT" },
  { no: -1, name: "UNDEFINED" },
]);

